import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function pincodeValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value: string = control.value;

    if (/^(\d)\1{3}$/.test(value)) {
      return { repeatingDigits: 'Pincode cannot have all identical digits' };
    }

    const sequentialNumbers = ['0123', '1234', '2345', '3456', '4567', '5678', '6789',
                               '9876', '8765', '7654', '6543', '5432', '4321', '3210'];

    if (sequentialNumbers.includes(value)) {
      return { sequentialDigits: 'Pincode cannot have sequential numbers' };
    }

    return null;
  };
}
